import { Logo } from "./Logo";

export const Footer = ({ t }) => (
  <footer className="bg-[#070B14] border-t border-[#D4AF37]/15 py-16">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-3 gap-12">
      <div>
        <Logo light />
        <p className="text-sm text-slate-500 leading-relaxed mt-6 max-w-xs">{t.footer.desc}</p>
      </div>

      <div>
        <h4 className="text-xs uppercase tracking-[0.25em] font-mono text-[#E2C376] mb-5">{t.footer.links}</h4>
        <ul className="space-y-3 text-sm text-slate-400">
          {["services", "about", "stats", "contact"].map((id) => (
            <li key={id}>
              <button onClick={() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })} className="hover:text-[#E5C365] transition-colors">
                {t.nav[id === "stats" ? "stats" : id === "about" ? "about" : id]}
              </button>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="text-xs uppercase tracking-[0.25em] font-mono text-[#E2C376] mb-5">{t.footer.legal}</h4>
        <ul className="space-y-2 text-sm text-slate-400">
          <li data-testid="footer-company-name" className="text-slate-200">Risc Goup Suisse SA</li>
          <li data-testid="footer-address">Route de Champ-Colin 12, 1260 Nyon</li>
          <li data-testid="footer-email">
            <a href="mailto:info@rgsuisse.com" className="hover:text-[#E5C365] transition-colors">info@rgsuisse.com</a>
          </li>
          <li data-testid="footer-legal-ide">IDE/UID : CHE-113.947.145</li>
          <li data-testid="footer-legal-fed">N° féd. : CH-660.2.847.007-6</li>
          <li className="text-slate-500">Sociétés d'audit et d'analyse des risques</li>
        </ul>
      </div>
    </div>
    <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-14 pt-8 border-t border-[#D4AF37]/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-slate-600 font-mono">
      <span>© {new Date().getFullYear()} Risc Goup Suisse SA. {t.footer.rights}</span>
      <span>Nyon · Suisse · {new Date().getFullYear() - 2007} ans</span>
    </div>
  </footer>
);
